import { ACHelmetContainer, SupersetDashboard } from '@emfood/shared';
import GoBackHeader from '@emfood/shared/src/components/go-back-header/go-back-header';

import { Card, Alert, AlertTitle } from '@mui/material';

import { SUPERSET_MAIN_DASHBOARD_ID } from 'src/config-global';

import { useSettingsContext } from 'src/components/settings';

export default function Reporting() {
  const settings = useSettingsContext();

  return (
    <ACHelmetContainer maxWidth={settings.themeStretch ? false : 'xl'} title="Reporting">
      <GoBackHeader heading="Reporting" disableGoBack />
      {SUPERSET_MAIN_DASHBOARD_ID ? (
        <Card sx={{ p: 3 }}>
          <SupersetDashboard
            dashboardId={SUPERSET_MAIN_DASHBOARD_ID}
            sx={{
              height: '800px',
            }}
          />
        </Card>
      ) : (
        <Alert severity="warning">
          <AlertTitle>Reporting Not Configured</AlertTitle>
          The reporting dashboard is not configured. Please contact your administrator.
        </Alert>
      )}
    </ACHelmetContainer>
  );
}
